
import { AfterViewInit, Component } from '@angular/core';
import { LoaderService } from '../../core/service/loader/loader.service';


@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent implements AfterViewInit {
  constructor(private loaderService: LoaderService) { }

  ngAfterViewInit(): void {
    this.loaderService.showLoader();
    if (window.particlesJS) {
      window.particlesJS('tsparticles1', {
        particles: {
          number: { value: 100 },
          color: { value: '#fff' },
          line_linked: { enable: true, color: '#fff' },
          move: { enable: true, speed: 6 }
        }
      });

      setTimeout(() => {
        this.loaderService.hideLoader();
      }, 1000);
    }
  }
}



